module.exports = __webpack_public_path__ + "static/Aliexpress-bf946bfe21cb7995274addde0a283941.webp";